import React from "react";
import { AppContext } from "../AppContext";

export default function useUserProfile() {
  //Hämta user profile från contextet tack.

  const appContext = React.useContext(AppContext); 
  return appContext.userProfile;
}

/*import { API, Auth, graphqlOperation, Hub } from "aws-amplify";
import { useEffect, useState } from "react";
import { getUserProfile } from "../graphql/queries";
let counter = 0;
export default function useUserProfile() {
  const [userProfile, setUserProfile] = useState(null);
  const onlyRunOnce = [];

  const fetchUserProfile = () => {
    counter++;
    document.title = counter + " hämta profile";
    const promise = Auth.currentAuthenticatedUser();
    promise.catch((e) => {
      //Ignore errors
    });
    promise.then((data) => {
      const id = data.attributes.sub;
      const variables = {
        id,
      };
      API.graphql(graphqlOperation(getUserProfile, variables)).then(
        (userProfileData) => setUserProfile(userProfileData.data.getUserProfile)
      );
    });
  };

  const listenForAuthChange = () => {
    const asdf = () => {
      console.log("Fetch user profile triggat av auth");
      fetchUserProfile();
    };
    Hub.listen("auth", asdf);
    return () => {
      Hub.remove("auth", asdf);
    };
  };

  const listenToCustomProfileUpdatedEvent = () => {
    const userProfileUpdatedListener = (event) => {
      fetchUserProfile();
    };
    document.addEventListener(
      "jojoo_profileupdated",
      userProfileUpdatedListener
    );

    return () => {
      document.removeEventListener(
        "jojoo_profileupdated",
        userProfileUpdatedListener
      );
    };
  };

  const asdf2 = () => {
    //Kör bara om user profile inte finns
    if(userProfile){
      console.log("körd INTE för", userProfile);
      return;
    }
    console.log("Nu är det när vi reggar en lyssnare i useUserProfile", userProfile);
    fetchUserProfile();
  };
  useEffect(asdf2, onlyRunOnce);
  useEffect(listenToCustomProfileUpdatedEvent, onlyRunOnce);
  useEffect(listenForAuthChange, onlyRunOnce);
  console.log("returnerar user profile", userProfile);
  return userProfile;
}*/
